// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"b59b0114","126":"c14d844c","162":"79528063","171":"3a45e186","453":"54292a4b"}[chunkId] + ".chunk.js";
};